export default __webpack_public_path__ + "static/media/adult-blur-countryside-552563.dc224fd0.jpg";